export const resolveQueryNotificationTask = async (
  tasks,
  inspectionId,
  queryId,
  fetchTasks
) => {
  const matches = (task) =>
    Number(task.inspectionId) === inspectionId &&
    Number(task.queryId) === queryId;
  const knownTask = tasks.find(matches);
  if (knownTask) return { task: knownTask };
  // A live notification can arrive before the page's task list refreshes.
  const response = await fetchTasks();
  if (!response?.status)
    throw new Error(
      response?.message || "Unable to load the query review task."
    );
  const refreshedTasks = response.data || [];
  return {
    refreshedTasks,
    task: refreshedTasks.find(matches) || {
      id: `query-${queryId}`,
      taskType: "QueryResponse",
      inspectionId,
      queryId,
    },
  };
};
